import storage from "../utils/storage";
/**
 *  判断是否为空
 * @param {any} value
 * @param {Boolean} flag 是否包含0,'0'或false
 * @return {Boolen} true是空,false是非空
 */
const _empty = function(value, flag = true) {
	switch (typeof value) {
		case 'undefined':
			return true;
		case 'string':
			if (value.replace(/(^[ \t\n\r]*)|([ \t\n\r]*$)/g, '').length == 0) return true;
			if (flag && '0' === value) return true;
			break;
		case 'boolean':
			if (flag && !value) return true;
			break;
		case 'number':
			if (flag && (0 === value || isNaN(value))) return true;
			break;
		case 'object':
			if (null === value || value.length === 0) return true;
			// 排除{}
			for (let i in value) return false;
			return true;
	}
	return false;
}

/**
 *  检查数据类型
 * @param {any} o 待检查的数据
 * @param string type 数据类型
 * @return bool
 */
const _check = function(o, type) {
	// 转换为小写
	const temp = type ? type.toLowerCase() : '';
	switch (temp) {
		case 'string': // 验证是否字符串		
			return Object.prototype.toString.call(o).slice(8, -1) === 'String';
		case 'number': // 验证是否是否数字
			return Object.prototype.toString.call(o).slice(8, -1) === 'Number';
		case 'bool': // 验证是否是Boolean
			return Object.prototype.toString.call(o).slice(8, -1) === 'Boolean';
		case 'function': // 验证是否是函数
			return Object.prototype.toString.call(o).slice(8, -1) === 'Function';
		case 'null': //是否为null
			return Object.prototype.toString.call(o).slice(8, -1) === 'Null';
		case 'undefined': //是否undefined
			return Object.prototype.toString.call(o).slice(8, -1) === 'Undefined';
		case 'object': //是否对象
			return Object.prototype.toString.call(o).slice(8, -1) === 'Object';
		case 'array': //是否数组
			if (typeof Array.isArray === "function") return Array.isArray(o);
			else return Object.prototype.toString.call(o).slice(8, -1) === 'Array';
		case 'date': // 是否时间对象
			return Object.prototype.toString.call(o).slice(8, -1) === 'Date';
		case 'regexp': //是否正则
			return Object.prototype.toString.call(o).slice(8, -1) === 'RegExp';
		case 'error': // 是否错误对象
			return Object.prototype.toString.call(o).slice(8, -1) === 'Error';
		case 'symbol': //是否Symbol函数
			return Object.prototype.toString.call(o).slice(8, -1) === 'Symbol';
		case 'promise': // 是否Promise对象
			return Object.prototype.toString.call(o).slice(8, -1) === 'Promise';
		case 'set': // 是否Set对象
			return Object.prototype.toString.call(o).slice(8, -1) === 'Set';
		default:
			return false;
	}
}

class ws {
	constructor(param) {
		this.url = param.url
		this.content = param.content //订订阅内容
		this.Heartbeat_s = param.Heartbeat_s || null //心跳间隔
		this.Heartbeat_time = null //心跳计时器
		this.Heartbeat_status = false //心跳状态
		this.Heartbeat_content = param.Heartbeat_content || {
			event: "ping"
		} //心跳内容，对象
		this.reconnect_s = param.reconnect_s || null //重连间隔
		this.reconnect_time = null //断开重连计时器
		this.reconnect_status = false
		this.success = param.success //成功回调
		this.error = param.error //失败回调
		this.from = "h5";
		this.init()
	}
	init() {
		this.ws = new WebSocket(this.url)
		this.ws.onopen = this.open.bind(this)
		this.ws.onmessage = this.message.bind(this)
		this.ws.onerror = this.err.bind(this)
	}
	open() {
		console.log('连接成功')
		this.closeReconnect() //关闭重新连接
		this.Heartbeat_status = false //重连成功关闭自动重连
		this.send(this.content)
		this.Heartbeat()

	}
	send(data) {
		const that = this;
		//组装发送信息
		let msg = data;
		if (_empty(msg) || _empty(msg.event)) {
			//console.log('错误提醒:发送数据没有类型');
			return false;
		}
		if (_empty(msg.from)) msg.from = that.from;
		if (_empty(msg.token)) {
			let userToken = storage.get("userToken");
			if (userToken) {
				msg['token'] = userToken;
			} else {
				msg['token'] = '';
			}
		}
		if (_empty(msg.data)) msg.data = ""; //默认数据
		//发送消息
		//console.log('连接状态：', this.ws.readyState);
		//console.log('发送内容：', msg);
		if (this.ws.readyState == 1) {
			this.ws.send(JSON.stringify(msg))
		} else if (this.ws.readyState == 3) {
			//console.log('错误重连开始');
			// 错误重连
			this.Heartbeat_status = false
			this.Heartbeat_s = 5000;
			this.closeHeartbeat() //防止错误之后还执行心跳
			this.Open_reconnect(this.reconnect_s)
		}

	}

	message(e) {
		const that = this;
		let data = JSON.parse(e.data);
		//console.log("----sss---", e);
		//console.log('收到服务器内容：', data);
		this.success && this.success(data)
	}
	close(e) {
		console.log("关闭了")
		this.closeHeartbeat() //关闭心跳
		this.ws.close()
		this.Heartbeat_status = false
		this.Heartbeat_s = null
		this.reconnect_status = false
	}
	err(e) {
		this.error && this.error(e)
		// 错误重连
		this.ws.close()
		this.closeHeartbeat() //防止错误之后还执行心跳
		this.Open_reconnect(this.reconnect_s)
	}
	// 手动开启心跳
	Open_heartbeat(s) {
		this.Heartbeat_s = s ? s : 5000
		if (this.ws.readyState == 1) {
			this.Heartbeat_status = true
			this.Heartbeat()
		} else {
			console.log('心跳开启失败,确认是否链接WebSocket,或者调用Open_reconnect方法重新连接')
		}
	}
	// 心跳
	Heartbeat() {
		this.Heartbeat_judgment()
		if (!this.Heartbeat_status && !this.Heartbeat_s) return
		this.closeHeartbeat()
		this.Heartbeat_time = setInterval(() => {
			//console.log('发送心跳数据', this.Heartbeat_content)
			this.send(this.Heartbeat_content)
			this.Heartbeat_status = true
		}, this.Heartbeat_s)
	}
	// 心跳判断 是否初始化时传入心跳
	Heartbeat_judgment() {
		// 为了更灵活还是足个设置吧
		if (this.Heartbeat_s) {
			this.Heartbeat_status = true
		} else {
			this.Heartbeat_status = false
		}
	}
	//关闭心跳
	closeHeartbeat() {
		clearInterval(this.Heartbeat_time)
	}
	// 关闭重新链接
	closeReconnect() {
		clearInterval(this.reconnect_time)
	}
	// 断开重连  重连次数下周在做
	Open_reconnect(time) {
		if (time) this.reconnect_s = time
		// 是否正在重连中
		if (this.Heartbeat_status) return
		// 安全起见先关闭一次
		this.close()
		if (!this.reconnect_s) return
		//console.log('正在重连')
		this.Heartbeat_s = 5000;
		this.init()
		this.reconnect_time = setInterval(() => {
			this.Heartbeat_status = true
			this.init()
		}, this.reconnect_s);
	}
}

export default ws
